import { Component, EventEmitter, Input, type OnChanges, Output, type SimpleChanges, ViewChild } from '@angular/core';
import { type ChartConfiguration, type ChartEvent, type ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-pie-chart',
  standalone: false,
  templateUrl: './pie-chart.component.html',
  styleUrl: './pie-chart.component.scss'
})
export class PieChartComponent implements OnChanges {
  @Input() title: string = 'Pie Chart';
  @Input() labels: string[] = [];
  @Input() data: number[] = [];
  @Input() count: number = 0;

  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  public pieChartType: ChartType = 'pie';
  public pieChartData: ChartConfiguration<'pie'>['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#EF5350', '#AB47BC']
      }
    ]
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['labels'] || changes['data']) {
      if (this.labels.length <= 5) {
        // Use as is
        this.pieChartData.labels = [...this.labels];
        this.pieChartData.datasets[0].data = [...this.data];
      } else {
        // Slice the top 5
        const topLabels = this.labels.slice(0, 5);
        const topData = this.data.slice(0, 5);

        // Sum the rest into "Other"
        const otherData = this.data.slice(5).reduce((sum, val) => sum + val, 0);

        this.pieChartData.labels = [...topLabels, 'Other'];
        this.pieChartData.datasets[0].data = [...topData, otherData];
      }

      // Add/extend background colors if needed
      const defaultColors = ['#42A5F5', '#66BB6A', '#FFA726', '#EF5350', '#AB47BC', '#BDBDBD']; // + grey for "Other"
      this.pieChartData.datasets[0].backgroundColor = defaultColors.slice(0, this.pieChartData.labels.length);

      this.chart?.update();
    }
  }

  @Output() chartClick = new EventEmitter<string>();

  public chartClicked({ active }: { event?: ChartEvent; active?: any[] }): void {
    // console.log('Chart clicked:', event, active);
    if (active && active.length) {
      const index = active[0].index;
      const label = this.labels[index];
      this.chartClick.emit(label);
    }
  }
}
